module.exports = __webpack_public_path__ + "static/media/folder-minus.a8bb880b.svg";